(function () {
  console.log("LCP Script");

  var latestLcp = null;
  var pushed = false;

  function getBucket(seconds) {
    if (seconds <= 2.5) return "good";
    if (seconds <= 4) return "needs_improvement";
    return "poor";
  }

  function pushLcpEvent(source) {
    if (pushed || latestLcp == null) return;

    pushed = true;

    var seconds = Number((latestLcp / 1000).toFixed(2));
    var bucket = getBucket(seconds);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "web_vitals_lcp",
      lcp_value: seconds,
      lcp_bucket: bucket,
      lcp_source: source || "observer"
    });

    console.log("web_vitals_lcp pushed", {
      lcp_value: seconds,
      lcp_bucket: bucket,
      lcp_source: source || "observer"
    });
  }

  function loadWebVitals() {
    var s = document.createElement("script");
    s.src = "https://unpkg.com/web-vitals@5/dist/web-vitals.iife.js";
    s.async = true;

    s.onload = function () {
      if (!window.webVitals || !window.webVitals.onLCP) return;

      window.webVitals.onLCP(function (metric) {
        latestLcp = metric.value;

        if (!pushed) {
          pushLcpEvent("lcp_update");
        }
      }, { reportAllChanges: true });

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") {
          pushLcpEvent("visibilitychange");
        }
      });

      window.addEventListener("pagehide", function () {
        pushLcpEvent("pagehide");
      });
    };

    s.onerror = function () {
      console.log("web-vitals failed to load");
    };

    document.head.appendChild(s);
  }

  loadWebVitals();
})();